import React from 'react';
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import {Button, Col, Container, Row} from "react-bootstrap";
import Aside from "./aside";
import NiveauCours from "./niveauCours";
import './reinscription.scss'
import IconTitle from "../../components/iconTitle";
import {
    faCheck,
    faExchangeAlt,
    faExclamationTriangle,
    faFolderPlus,
    faInfo,
    faLink,
    faNotEqual,
    faTimes
} from "@fortawesome/pro-solid-svg-icons";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import Commentaire from "./commentaire";
import Informations from "./informations";
import {toast} from "react-toastify";

class PAE extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            stillSubmit: false,
            isSubmit: false,
            commentaire: null,
            contraintes: null,
            niveauxCours: [],
            selected: {
                ECTS: 0,
                item: []
            },
        }
    }

    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        return nextState.selected !== this.state.selected
            || nextState.niveauxCours !== this.state.niveauxCours
            || nextState.isSubmit !== this.state.isSubmit
    }

    async componentDidMount(): void {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.Reinscription}06`);
        let contraintes = body;

        ({body} = await Get(`/v1/extranet/student/${screens.PAE}`));

        let selected = [];

        body.forEach(nc => {
            selected = selected.concat(nc.Cours.filter(f => f.Select || (!f.Select && f.Preselection && (f.IsDecoche == null || f.IsDecoche))));
        });

        selected = selected.filter((v, i, a) => a.findIndex(t => t.UniteEnseignementID === v.UniteEnseignementID) === i);

        this.setState({
            contraintes: contraintes,
            commentaire: contraintes.Commentaire,
            isSubmit: contraintes.IsSubmit,
            niveauxCours: body,
            selected: {
                ECTS: selected.reduce((a, b) => (a + parseInt(b.ECTS)), 0),
                item: selected
            }
        }, async () => {
            if (!contraintes.IsSubmit) {
                let save = Object.assign({}, this.state.selected);
                save.commentaire = this.state.commentaire;
                await Post(`/v1/extranet/student/${screens.PAE}`, save);
            }
        });
    }

    async save(isSubmit = false, confirm = false) {
        if (!this.state.stillSubmit) {
            this.setState({
                stillSubmit: true
            }, async () => {

                if (isSubmit && !confirm) {
                    window.scrollTo({top: 0, behavior: 'smooth'});

                    let toastID = toast.info(<>
                        <div className={"mb-4"}>
                            {this.state.selected.ECTS < 60 &&
                                <div className={"pb-2 pl-2"}>Vous avez soumis un PAE inférieur à 60 crédits, merci de
                                    confirmer qu’il s’agit bien de votre choix</div>}
                            <div className={"pb-2 pl-2"}>Avez-vous vérifié les messages d'avertissements éventuels ?
                            </div>
                            <div className={"pb-2 pl-2"}>Êtes-vous sûr de vouloir soumettre ?</div>
                        </div>
                        <Button block className={"m-2"}
                                size={"lg"}
                                onClick={() => {
                                    toast.update(toastID, {autoClose: 1});
                                    this.setState({stillSubmit: false}, () => this.save(true, true));
                                }}
                                variant={"success"}>Confirmer</Button>
                        <Button block className={"m-2"}
                                size={"lg"}
                                onClick={() => {
                                    toast.update(toastID, {autoClose: 1});
                                    this.setState({stillSubmit: false});
                                }}
                                variant={"warning"}>Modifier</Button>
                    </>, {autoClose: false, closeOnClick: false, onClose: () => this.setState({stillSubmit: false})});
                }

                if (isSubmit && !confirm) return;

                let save = Object.assign({}, this.state.selected);
                save.commentaire = this.state.commentaire;
                save.submit = isSubmit;

                await Post(`/v1/extranet/student/${screens.PAE}`, save, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

                this.setState({
                    isSubmit: isSubmit,
                    stillSubmit: false,
                })
            });
        }
    }

    updateSelected(item) {
        let selected = [...this.state.selected.item];
        let ECTS;

        this.addRemoveSelected(selected, item);

        let niveauxCours = this.updateDependances(item, selected);

        selected.sort((a, b) => a.UniteEnseignementCode > b.UniteEnseignementCode ? 1 : -1);

        ECTS = selected.reduce((a, b) => (a + parseInt(b.ECTS)), 0);

        this.setState({
            selected: {
                ECTS: ECTS,
                item: selected
            },
            niveauxCours: niveauxCours
        });
    }

    addRemoveSelected(selected, item) {
        if (selected.some(f => item.UniteEnseignementID === f.UniteEnseignementID)) {
            selected.splice(selected.findIndex(f => item.UniteEnseignementID === f.UniteEnseignementID), 1);

            if (item.Preselection && (item.IsDecoche == null || item.IsDecoche)) selected.push(item);

        } else {
            selected.push(item);
        }
    }

    updateDependances(item, selected) {
        let niveauxCours = this.state.niveauxCours;

        niveauxCours = this.updateIncompatibilites(niveauxCours, item);
        niveauxCours = this.updateOptionsGroupees(niveauxCours, item, selected);

        return niveauxCours;
    }

    updateIncompatibilites(prevNiveauxCours, item) {
        if (item.Incompatibilites.length > 0) {
            item.Incompatibilites.forEach(i => {
                prevNiveauxCours.forEach((nc, index) => {
                    let find = nc.Cours.findIndex(f => f.UniteEnseignementCode === i.RequisCode);

                    if (find !== -1) {
                        prevNiveauxCours = prevNiveauxCours.map((v, i) => i === index ?
                            {
                                ...v,
                                Cours: v.Cours.map((c, f) => f === find ? {
                                    ...c,
                                    NotSelectable: !c.NotSelectable,
                                    CanSelect: c.NotSelectable,
                                } : c)
                            } : v);
                    }
                })
            });
        }

        return prevNiveauxCours;
    }

    updateOptionsGroupees(prevNiveauxCours, item, selected) {

        let codeAlreadyChange = [];

        if (item.Corequis.length > 0 && this.state.contraintes.IsOptionsGroupees) {

            //Chercher un autre lui-même
            prevNiveauxCours.forEach((nc, index) => {
                let find = nc.Cours.findIndex(f => f.UniteEnseignementCode === item.UniteEnseignementCode);

                if (find !== -1) {
                    prevNiveauxCours = prevNiveauxCours.map((v, i) => i === index ?
                        {
                            ...v,
                            Cours: v.Cours.map((c, f) => f === find ? {
                                ...c,
                                Select: item.Select,
                            } : c)
                        } : v);
                }
            })

            item.Corequis.forEach(i => {
                prevNiveauxCours.forEach((nc, index) => {
                    let find = nc.Cours.findIndex(f => f.UniteEnseignementCode === i.RequisCode);

                    if (find !== -1) {
                        prevNiveauxCours = prevNiveauxCours.map((v, i) => i === index ?
                            {
                                ...v,
                                Cours: v.Cours.map((c, f) => f === find ? {
                                    ...c,
                                    Select: item.Select,
                                } : c)
                            } : v);

                        let change = codeAlreadyChange.findIndex(f => f === i.RequisCode);
                        if (change === -1) {
                            this.addRemoveSelected(selected, prevNiveauxCours[index].Cours[find]);
                            codeAlreadyChange.push(i.RequisCode);
                        }
                    }
                })
            });
        }

        return prevNiveauxCours;
    }

    updateCommentaire(commentaire = null) {
        this.setState({
            commentaire: commentaire
        });
    }

    render() {
        return (
            <section>
                {this.state.isSubmit ? this.renderSubmitted() : this.renderConstructionProgramme()}
            </section>
        );
    }

    renderConstructionProgramme() {
        const Legende = () => {
            return (
                <>
                    <div style={{"fontSize": "1.25rem"}} className={"text-primary py-1 px-4"}>
                        <IconTitle type={"div"} icon={faInfo} content={"Fiche descriptive"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-danger py-1 px-4"}>
                        <IconTitle type={"div"} icon={faExchangeAlt} content={"UE avec prérequis"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-warning py-1 px-4"}>
                        <IconTitle type={"div"} icon={faLink} content={"UE avec corequis"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-dark py-1 px-4"}>
                        <IconTitle type={"div"} icon={faNotEqual} content={"UE incompatible"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-white bg-dark py-1 px-4"}><span
                        className={"pl-1 pr-3"}>D&nbsp;&nbsp;</span> UE dispensée
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-white bg-success py-1 px-4"}>
                        <IconTitle type={"div"} icon={faCheck} content={"UE validée"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-white bg-danger py-1 px-4"}>
                        <IconTitle type={"div"} icon={faTimes} content={"UE inselectionnable"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-white bg-warning py-1 px-4"}>
                        <IconTitle type={"div"} icon={faExclamationTriangle} content={"UE déselectionnée"}/>
                    </div>
                    <div style={{"fontSize": "1.25rem"}} className={"text-white bg-primary py-1 px-4"}>
                        <IconTitle type={"div"} icon={faFolderPlus} content={"UE selectionnée"}/>
                    </div>
                </>
            );
        };

        return <>
            <Container>
                <Row>
                    <Col xs={12} md={3}>
                        <div className={"aside"}>
                            <Legende/>
                            <Aside {...this.state.selected}/>
                        </div>
                    </Col>
                    <Col xs={12} md={9}>
                        <div className={"buttons"}>
                            <div>
                                <Button block className={"mx-2"}
                                        size={"lg"}
                                        onClick={() => this.refCommentaire.update(true, false, this.state.commentaire)}
                                        variant={"light"}>Commenter</Button>
                                <Button block className={"mx-2 mt-0"}
                                        size={"lg"}
                                        onClick={() => this.save()}
                                        variant={"primary"}>Sauvegarder</Button>
                                <Button block className={"mx-2 mt-0"}
                                        size={"lg"}
                                        onClick={() => this.save(true)}
                                        variant={"success"}>Soumettre</Button>
                            </div>
                        </div>
                        <Informations selected={this.state.selected}
                                      contraintes={this.state.contraintes}/>
                        {this.state.niveauxCours.map((nc, k) => (<NiveauCours key={k}
                                                                              updateSelected={this.updateSelected.bind(this)}
                                                                              item={nc}/>))}
                    </Col>
                </Row>
            </Container>
            <Commentaire ref={r => this.refCommentaire = r}
                         update={this.updateCommentaire.bind(this)}/>
        </>;
    }

    renderSubmitted() {
        return (
            <>
                <h4>Votre programme a bien été soumis à votre gestionnaire de dossier.</h4>
                <p>Vous serez informé par mail lorsque vous serez invité à le signer ou à y apporter des modifications
                    nécessaires.</p>
                <a href={process.env.APP_ROOT + "desktop"}>Retour à l'accueil</a>
            </>
        );
    }
}

export default withRouter(PAE);